import ISO6391 from 'iso-639-1'

export function getAllLanguagesFromISO() {
  return ISO6391.getAllCodes().reduce((languagesMap, code) => {
    languagesMap[code] = ISO6391.getNativeName(code)
    return languagesMap
  }, {})
}
